import { render, staticRenderFns } from "./PartnerCreateRequirementsList.vue?vue&type=template&id=393ab7db&"
import script from "./PartnerCreateRequirementsList.vue?vue&type=script&lang=ts&"
export * from "./PartnerCreateRequirementsList.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerCreateRequirementsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
